import { unstable_cache as cache } from 'next/cache';
import { API_MAP } from '../api.map';

const getReviewListByPageOnServer = async (page: number, per_page: number) => {
  const cacheKey = `review-list-${page}-${per_page}`;
  return cache(
    async () => {
      const response = await fetch(`${API_MAP.GET_REVIEW_LIST}?page=${page}&per_page=${per_page}`, {
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return response.json();
    },
    [cacheKey],
    {
      tags: ['review-list', cacheKey],
      revalidate: 600,
    }
  )();
};

export { getReviewListByPageOnServer };
